<span class="previous-claims-link" (click)="openPreviousClaimDetails(data.id)">{{data[fieldName]}}</span>
